import React, { FC } from "react";
import { Card as MuiCard, CardProps } from "@mui/material";

const Card: FC<CardProps> = (props) => <MuiCard {...props} />;

export default Card;
